import { render, staticRenderFns } from "./IndividualImprintsComponent.vue?vue&type=template&id=6c3da1f8&scoped=true&"
import script from "./IndividualImprintsComponent.vue?vue&type=script&lang=js&"
export * from "./IndividualImprintsComponent.vue?vue&type=script&lang=js&"
import style0 from "./IndividualImprintsComponent.vue?vue&type=style&index=0&id=6c3da1f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3da1f8",
  null
  
)

export default component.exports